var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "registor" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "login-box", attrs: { align: "center" } }, [
        _c("div", { staticClass: "main-text", attrs: { align: "center" } }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.status == "signin"
                  ? _vm.l10.Signin_Title1
                  : _vm.status == "signup"
                  ? _vm.l10.Signup_Title1
                  : _vm.status == "recover"
                  ? _vm.l10.FindPassword_Title1
                  : ""
              ) +
              "\n            "
          ),
        ]),
        _vm._v(" "),
        _vm.status == "signin"
          ? _c("form", [
              _c("div", { staticClass: "form1" }, [
                _c("input", {
                  staticClass: "user signin-user",
                  attrs: {
                    type: "email",
                    align: "center",
                    placeholder: _vm.l10.Signin_InputBox1,
                  },
                  on: { input: _vm.handleChangeSigninInput },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "form1 signin" }, [
                _c("input", {
                  staticClass: "pass signin-pass",
                  attrs: {
                    type: "password",
                    align: "center",
                    placeholder: _vm.l10.Signin_InputBox2,
                  },
                  on: { input: _vm.handleChangeSigninInput },
                }),
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "red-btn-popup" } }, [
                _c("p", { staticClass: "wrong-text" }, [
                  _vm._v(_vm._s(_vm.errorMessage)),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "red-btn",
                  attrs: { type: "button", value: _vm.l10.Signin_Button1 },
                  on: { click: _vm.handleSigninClick },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status == "signup"
          ? _c("form", [
              _c("div", { staticClass: "form1" }, [
                _c("input", {
                  staticClass: "user signup-user",
                  attrs: {
                    type: "email",
                    align: "center",
                    placeholder: _vm.l10.Signup_InputBox1,
                  },
                  on: { input: _vm.handleChangeSigninInput },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { staticClass: "form1" }, [
                _c("input", {
                  staticClass: "pass signup-pass",
                  attrs: {
                    type: "password",
                    align: "center",
                    placeholder: _vm.l10.Signup_InputBox2,
                  },
                  on: { input: _vm.handleChangeSigninInput },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form1" }, [
                _c("input", {
                  staticClass: "pass-check signup-passcheck",
                  attrs: {
                    type: "password",
                    align: "center",
                    placeholder: _vm.l10.Signup_InputBox3,
                  },
                  on: { input: _vm.handleChangeSigninInput },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form1" }, [
                _c(
                  "label",
                  { staticClass: "checkbox-label", attrs: { align: "left" } },
                  [
                    _vm._v(
                      _vm._s(_vm.l10.Signup_agree__Title2) +
                        "\n                        "
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.adultAgreement,
                          expression: "adultAgreement",
                        },
                      ],
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.adultAgreement)
                          ? _vm._i(_vm.adultAgreement, null) > -1
                          : _vm.adultAgreement,
                      },
                      on: {
                        input: _vm.handleChangeSigninInput,
                        change: function ($event) {
                          var $$a = _vm.adultAgreement,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.adultAgreement = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.adultAgreement = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.adultAgreement = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      class: [
                        "checkbox-custom",
                        _vm.adultAgreement ? "checked" : "",
                      ],
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form1" }, [
                _c("label", { staticClass: "checkbox-label" }, [
                  _vm._v(
                    _vm._s(_vm.l10.Signup_agree__Title3) +
                      "\n                        "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.marketingAgreement,
                        expression: "marketingAgreement",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.marketingAgreement)
                        ? _vm._i(_vm.marketingAgreement, null) > -1
                        : _vm.marketingAgreement,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.marketingAgreement,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              (_vm.marketingAgreement = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.marketingAgreement = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.marketingAgreement = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    class: [
                      "checkbox-custom",
                      _vm.marketingAgreement ? "checked" : "",
                    ],
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "text-link signup" }, [
                _vm._v(_vm._s(_vm.tosAndPi[0]) + "\n                    "),
                _c(
                  "span",
                  {
                    staticClass: "btn",
                    style: _vm.lang == "cn" ? "margin-left: -3px;" : "",
                    on: {
                      click: function ($event) {
                        return _vm.handleLinkClick("/cn/tos")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.tosAndPi[1]))]
                ),
                _vm._v(_vm._s(_vm.tosAndPi[2]) + "\n                    "),
                _c(
                  "span",
                  {
                    staticClass: "btn",
                    style: _vm.lang == "cn" ? "margin-left: -3px;" : "",
                    on: {
                      click: function ($event) {
                        return _vm.handleLinkClick("/cn/privacy")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.tosAndPi[3]))]
                ),
                _vm._v(_vm._s(_vm.tosAndPi[4]) + "\n                "),
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "red-btn-popup" } }, [
                _c("p", { staticClass: "wrong-text" }, [
                  _vm._v(_vm._s(_vm.errorMessage)),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "red-btn",
                  attrs: {
                    type: "button",
                    value: _vm.l10.All_Parents_SignupAgreement_Title1_Button1,
                  },
                  on: { click: _vm.handleRequestSignup },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status == "recover"
          ? _c("form", [
              _c("div", { staticClass: "form1" }, [
                _c("input", {
                  staticClass: "user recover-user",
                  attrs: {
                    type: "email",
                    align: "center",
                    placeholder: _vm.l10.FindPassword_InputBox1,
                  },
                  on: { input: _vm.handleChangeSigninInput },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }),
              _vm._v(" "),
              _c("div", { attrs: { id: "red-btn-popup" } }, [
                _c("p", { staticClass: "wrong-text" }, [
                  _vm._v(_vm._s(_vm.errorMessage)),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "red-btn",
                  attrs: {
                    type: "button",
                    value: _vm.l10.FindPassword_Button1,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.requestRecoverAccount()
                    },
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status != "recover"
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "member-signup btn",
                  on: {
                    click: function ($event) {
                      return _vm.handleSignupClick()
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.status == "signin"
                          ? _vm.l10.Signin_Textlink1
                          : _vm.l10.Signin_Title1
                      )
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "spliter" }, [_vm._v("|")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "forgot btn",
                  on: { click: _vm.handleForgotClick },
                },
                [_c("span", [_vm._v(_vm._s(_vm.l10.Signin_Textlink2))])]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.status == "recover"
          ? _c("div", [
              _c(
                "div",
                {
                  staticClass: "member-signup btn",
                  on: {
                    click: function ($event) {
                      return _vm.handleSignupClick("signin")
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.l10.Signin_Title1))])]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "spliter" }, [_vm._v("|")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "member-signup btn",
                  on: {
                    click: function ($event) {
                      return _vm.handleSignupClick("signup")
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.l10.Signin_Textlink1))])]
              ),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }